import { t } from '@lingui/core/macro';
import { VStack } from '@chakra-ui/react';

import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

import buildLinkToEnrolments from '../../utils/buildLinkToEnrolments';
import ContentContainer from './shared/ContentContainer';
import ProgressBarCard from './shared/ProgressBarCard';
import SidePanelContentHeader from './shared/ContentHeader';
import NoDataMessage from './shared/NoDataMessage';

import PieZeroToTwentyFive from './icons/PieZeroToTwentyFive';
import PieTwentyFiveToSeventyFive from './icons/PieTwentyFiveToSeventyFive';
import PieSeventyFivePlus from './icons/PieSeventyFivePlus';

function SemesterProgressWithData() {
  const { filters } = useFiltersContext();
  const { data } = trpcTenant.dashboard.getSemesterProgressByHealthStatus.useQuery(
    { filters },
    { suspense: true },
  );

  if (data === undefined) {
    return <NoDataMessage />;
  }

  const { lessThanTwentyFive, twentyFiveToSeventyFive, seventyFivePlus } = data;

  return (
    <>
      <SidePanelContentHeader
        title={t`Semester Progress`}
        tooltipText={t`Semester progress broken down by enrolment health`}
      />

      <VStack spacing={2} align="flex-start">
        <ProgressBarCard
          title={t`<25% Complete`}
          titleIcon={<PieZeroToTwentyFive />}
          titleColor="orange.500"
          total={lessThanTwentyFive.total}
          data={lessThanTwentyFive.data}
          to={buildLinkToEnrolments({ percent: 'l25' })}
        />

        <ProgressBarCard
          title={t`25-74% Complete`}
          titleIcon={<PieTwentyFiveToSeventyFive />}
          titleColor="yellow.500"
          total={twentyFiveToSeventyFive.total}
          data={twentyFiveToSeventyFive.data}
          to={buildLinkToEnrolments({ percent: '25-75' })}
        />

        <ProgressBarCard
          title={t`75%+ Complete`}
          titleIcon={<PieSeventyFivePlus />}
          titleColor="blue.500"
          total={seventyFivePlus.total}
          data={seventyFivePlus.data}
          to={buildLinkToEnrolments({ percent: 'g75' })}
        />
      </VStack>
    </>
  );
}

export default function SemesterProgress() {
  return (
    <ContentContainer title={t`Progress`}>
      <SemesterProgressWithData />
    </ContentContainer>
  );
}
